import {
  jb_publication_download_overlay_css_default
} from "./chunk.B4IZST7S.js";
import {
  JbModal
} from "./chunk.ANE27JCW.js";
import {
  disableBodyScroll,
  enableBodyScroll
} from "./chunk.A7Z76YXE.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  Spaceable
} from "./chunk.JI7MO3NT.js";
import {
  Animatable
} from "./chunk.V3FEQEPV.js";
import {
  recenterNavItems
} from "./chunk.JTCOOS2A.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-publication-download-overlay/jb-publication-download-overlay.ts
var JbPublicationDownloadOverlay = class extends Spaceable(Initiable(Animatable(i))) {
  constructor() {
    super(...arguments);
    this.noLogo = false;
    this.open = false;
    this.withNewsletterSignup = false;
  }
  _getContentSpacingProperties() {
    return { grid: true, colsMdUp: 12 };
  }
  render() {
    return b`
      <div class="publication-download-overlay">
        <jb-publication-download
          class="in-overlay"
          .agreementFieldName=${this.agreementFieldName ?? A}
          .emailFieldName=${this.emailFieldName ?? A}
          .formAction=${this.formAction}
          .features=${this.features}
          .picture=${this.picture}
          .link=${this.link}
          ?skipDownloadPage=${this.skipDownloadPage}
          .texts=${this.texts}
          ?withNewsletterSignup=${this.withNewsletterSignup}
        ></jb-publication-download>
      </div>
    `;
  }
};
JbPublicationDownloadOverlay.styles = [reset_css_default, jb_publication_download_overlay_css_default];
__decorateClass([
  n()
], JbPublicationDownloadOverlay.prototype, "agreementFieldName", 2);
__decorateClass([
  n()
], JbPublicationDownloadOverlay.prototype, "emailFieldName", 2);
__decorateClass([
  n({ type: Array })
], JbPublicationDownloadOverlay.prototype, "features", 2);
__decorateClass([
  n()
], JbPublicationDownloadOverlay.prototype, "formAction", 2);
__decorateClass([
  n({ type: Object })
], JbPublicationDownloadOverlay.prototype, "link", 2);
__decorateClass([
  n({ type: Boolean })
], JbPublicationDownloadOverlay.prototype, "noLogo", 2);
__decorateClass([
  n({ type: Boolean })
], JbPublicationDownloadOverlay.prototype, "open", 2);
__decorateClass([
  n({ type: Number })
], JbPublicationDownloadOverlay.prototype, "overlayId", 2);
__decorateClass([
  n({ type: Object })
], JbPublicationDownloadOverlay.prototype, "picture", 2);
__decorateClass([
  n({ type: Boolean })
], JbPublicationDownloadOverlay.prototype, "skipDownloadPage", 2);
__decorateClass([
  n({ type: Object })
], JbPublicationDownloadOverlay.prototype, "texts", 2);
__decorateClass([
  n({ type: Boolean })
], JbPublicationDownloadOverlay.prototype, "withNewsletterSignup", 2);
JbPublicationDownloadOverlay = __decorateClass([
  customElement("jb-publication-download-overlay")
], JbPublicationDownloadOverlay);
bindEvents();

// src/components/jb-publication-download-overlay/jb-publication-download-overlay-controller.ts
var JbPublicationDownloadOverlayController = class {
  constructor() {
    this.overlay = void 0;
    this.publicationOverlay = void 0;
  }
  async close() {
    if (this.publicationOverlay) {
      await this.publicationOverlay.hide();
      enableBodyScroll(this.publicationOverlay);
      recenterNavItems();
    }
    if (this.overlay) {
      this.overlay.unstack();
    }
    this.overlay = void 0;
  }
  open(event) {
    const customEvent = event;
    if (!customEvent.detail.publicationOverlay) {
      return;
    }
    customEvent.stopPropagation();
    customEvent.detail.clickEvent.preventDefault();
    customEvent.detail.clickEvent.stopPropagation();
    this.publicationOverlay = new JbPublicationDownloadOverlay().init({
      props: {
        agreementFieldName: customEvent.detail.publicationOverlay.agreementFieldName,
        emailFieldName: customEvent.detail.publicationOverlay.emailFieldName,
        features: customEvent.detail.publicationOverlay.features,
        formAction: customEvent.detail.publicationOverlay.formAction,
        link: customEvent.detail.publicationOverlay.link,
        picture: customEvent.detail.publicationOverlay.picture,
        skipDownloadPage: customEvent.detail.publicationOverlay.skipDownloadPage,
        texts: customEvent.detail.publicationOverlay.texts,
        withNewsletterSignup: customEvent.detail.publicationOverlay.withNewsletterSignup,
        slot: "content"
      }
    });
    this.overlay = new JbModal().init({
      props: {
        ariaLabels: {
          label: customEvent.detail.publicationOverlay.texts.downloadTitle || void 0
        },
        color: "white",
        hasLogo: false,
        newAnimation: true,
        returnFocusTo: customEvent.detail.linkTag
      },
      childNodes: [this.publicationOverlay]
    });
    if (this.overlay) {
      this.overlay.stack();
      customElements.whenDefined("jb-publication-download-overlay").then(async () => {
        setTimeout(() => {
          this.publicationOverlay.contentChildren = Array.from(
            this.publicationOverlay.shadowRoot.querySelectorAll(".publication-download-overlay")
          );
        }, 0);
        disableBodyScroll(this.publicationOverlay, { allowTouchMove: () => true });
        recenterNavItems();
        await this.publicationOverlay.reveal();
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
        }, 150);
      });
    }
  }
};
var controller = new JbPublicationDownloadOverlayController();
function bindEvents() {
  document.addEventListener("jb-modal:close", () => {
    controller.close();
  });
  document.addEventListener("jb-link:clicked", (event) => {
    controller.open(event);
  });
}

export {
  bindEvents,
  JbPublicationDownloadOverlay
};
